export default "__VITE_ASSET__ppH63cWd__"